import { z } from 'zod'

import { ShippingAddressSchema } from '@/domain/shared/schemas/shipping-address.schema'

export const UpdateCartSchema = z.object({
    cart_id: z.string().min(1),
    region_id: z.string().optional(),
    sales_channel_id: z.string().optional(),
    country_code: z.string().optional(),
    items: z
        .array(
            z.object({
                variant_id: z.string(),
                quantity: z.number(),
            }),
        )
        .optional(),
    context: z.record(z.unknown()).optional(),
    email: z.string().email().optional(),
    customer_id: z.string().optional(),
    billing_address: z.union([z.string(), z.object({})]).optional(),
    shipping_address: ShippingAddressSchema.optional(),
    gift_cards: z.array(z.object({})).optional(),
    discounts: z.array(z.object({})).optional(),
})
